import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'profile-alias',
  templateUrl: './profile-alias.component.html',
  providers: []
})

export class ProfileAliasComponent {
  @Input() options: any;
  @Output() onViewProfile: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  openViewProfilePopup(data, key): void {
    data['key'] = key;
    data['visibility'] = this.options['visibility'];
    this.onViewProfile.emit(data);
  }
}